import React from "react"
import { useStores } from "../../models"
import { formatMentionId } from "../../utils/format"
import styled from '~/ui/styled'
import { MessageProps } from "./message.props"
import { observer } from "mobx-react-lite"
import MessageSent from "./message-sent"
import MessageReceived from "./message-received"

const Text = styled.Text<{ byMe: boolean; color?: string }>`
  display: inline;
  font-size: ${({ theme }) => theme.fontSizes.lg};
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
  overflow-wrap: break-word;
  color: ${({ theme, byMe, color }) =>
    color || (byMe ? theme.colors.textLight : theme.colors.text)};
`

// 文本消息
export const MentionMessage: React.FC<MessageProps> = observer(({ message, color }) => {
  const { userStore } = useStores()
  const content = formatMentionId(message?.content, message?.mention_ids, userStore)
  return <Text color={color} byMe={message.byMe} reply={message.reply_msg_id}>{content}</Text>
})

export const WrappedMentionMessage: React.FC<MessageProps> = (props) => {
  return props.message.byMe ? (
    <MessageSent {...props} Component={MentionMessage} />
  ) : (
    <MessageReceived {...props} Component={MentionMessage} />
  )
}
export default WrappedMentionMessage
